import MuiChip, { ChipProps } from '@material-ui/core/Chip';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Colors } from 'react-scale/components/legacy-css/global_css';

type AllowedMUIChipProps =
  | 'avatar'
  | 'className'
  | 'clickable'
  | 'onClick'
  | 'color'
  | 'disabled'
  | 'icon'
  | 'label'
  | 'deleteIcon'
  | 'onDelete'
  | 'size'
  | 'style'
  | 'variant';

const Chip = withStyles(theme => {
  const mediumIconOffset = 2;
  return {
    root: {
      backgroundColor: Colors.RemoGray05,
      color: '#000',
    },
    label: {
      fontSize: '14px',
      lineHeight: '20px',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    labelSmall: {
      fontSize: '11px',
      lineHeight: '16px',
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
    },
    icon: {
      width: `16px !important`,
      height: 16,
      marginLeft: theme.spacing(1) - mediumIconOffset,
    },
    iconSmall: {
      width: '12px !important',
      height: 12,
      marginLeft: theme.spacing(0.5),
    },
    deleteIcon: {
      marginRight: theme.spacing(1) - mediumIconOffset,
      width: 16,
      height: 16,
      color: 'rgba(0,0, 0, 0.5)',
    },
    deleteIconSmall: {
      width: 12,
      height: 12,
      marginRight: theme.spacing(0.5),
    },
    deleteIconColorPrimary: {
      color: 'rgba(255, 255, 255, 0.5)',
    },
    deleteIconColorSecondary: {
      color: 'rgba(43, 153, 216, 0.8)',
      '&:hover': {
        color: Colors.RemoBlue,
      },
    },
    colorPrimary: {
      backgroundColor: Colors.RemoBlue,
      color: '#fff',
    },
    colorSecondary: {
      backgroundColor: `rgba(43, 153, 216, 0.2)`,
      color: Colors.RemoBlue,
    },
  };
})(MuiChip);

export default Chip as React.FC<Pick<ChipProps, AllowedMUIChipProps>>;
